import { withBemMod } from '@bem-react/core';
import React from 'react';
import { Omit } from 'utility-types';

import HtmlContent from 'client/common/components/html-content';
import { ILevelMedia } from 'client/common/types';

import { cnLevel, ILevelProps } from '..';

import './level_type_thumb.css';

export interface ILevelTypeThumbProps extends Omit<ILevelMedia, 'type'> {
    type?: 'thumb';
}

export const withLevelTypeThumb = withBemMod<ILevelTypeThumbProps, ILevelProps>(
    cnLevel(),
    { type: 'thumb' },
    // eslint-disable-next-line complexity
    (BaseLevel: React.FC<ILevelProps>) => props => {
        const { title, subtitle, textAlign, description, blocks, ...otherProps } = props;

        const imageSrc = blocks && blocks.length > 0 && blocks[0].image;

        const alignMod = textAlign ? { align: textAlign } : {};

        return (
            <BaseLevel {...otherProps}>
                <>
                    {title && (
                        <h2
                            className={cnLevel('title')}
                            dangerouslySetInnerHTML={{ __html: title }}
                            />
                    )}
                    {subtitle && (
                        <h3
                            className={cnLevel('subtitle')}
                            dangerouslySetInnerHTML={{ __html: subtitle }}
                            />
                    )}
                    <div className={cnLevel('content', alignMod)}>
                        {description && (
                            <HtmlContent
                                className={cnLevel('description')}
                                content={description}
                                />
                        )}
                        {imageSrc && <img className={cnLevel('image')} src={imageSrc} alt="" />}
                    </div>
                </>
            </BaseLevel>
        );
    }
);
